<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [validationRules]="validationRulesMap"
    (searchClick)="searchClick()" [validationV2]="validationV2" [warningMessage]="warningMessage"
    (clear)="clear()">
</dk-ctl-sablon>  
<dx-popup *ngIf="crudPopupVisible"
    title="Belge Türleri"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>
        <dk-ctl-vgas-birim-dosya-belge-arama
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)"
        ></dk-ctl-vgas-birim-dosya-belge-arama>
</dx-popup>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>

